import { memo, useContext, useLayoutEffect } from "react";
import { DownloadApplicationLink, MarketplaceIcon } from "../../common";
import styles from "./main-page.module.css";
import { LocalizationContext } from "../context/LocalizationContext";

export const NoAppContent = memo(() => {
  const href = DownloadApplicationLink();
  const Icon = MarketplaceIcon();
  const localizationContext = useContext(LocalizationContext);


  useLayoutEffect(() => {
    window.location.href = href;
  }, []);

  return (
    <>
      <span className={styles.qrTitle}>{localizationContext?.localization.noappmessage}</span>
      <a href={href} className={styles.mobileLinkButton}>
        <Icon width="2.25rem" height="2.25rem" />
        <span>{localizationContext?.localization.downloadappbutton}</span>
      </a>
    </>
  );
});
